import { experience } from "../data/content";

export default function ExperienceTimeline() {
  return (
    <section data-testid="experience-timeline" className="py-24 md:py-32" style={{ backgroundColor: "var(--surface)" }}>
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-14">
          <div className="overline">Career</div>
          <h2 className="font-serif text-4xl md:text-5xl mt-3" style={{ color: "var(--primary)" }}>
            Fifteen years. Five companies. Countless Gigawatts.
          </h2>
        </div>

        <div className="relative grid md:grid-cols-12 gap-8">
          <div className="hidden md:block md:col-span-1 relative">
            <div className="absolute left-1/2 top-2 bottom-2 w-px tl-line" />
          </div>
          <ol className="md:col-span-11 space-y-10">
            {experience.map((e, i) => (
              <li
                key={`${e.company}-${i}`}
                data-testid={`experience-item-${i}`}
                className="grid md:grid-cols-12 gap-6 items-start"
              >
                <div className="md:col-span-3 font-mono text-xs uppercase tracking-widest" style={{ color: "var(--text-secondary)" }}>
                  {e.period}
                </div>
                <div className="md:col-span-9 p-6 md:p-8" style={{ backgroundColor: "var(--bg)", border: "1px solid var(--border-soft)" }}>
                  <div className="flex flex-wrap items-baseline gap-x-4 gap-y-1">
                    <h3 className="font-serif text-2xl" style={{ color: "var(--primary)" }}>{e.role}</h3>
                    <span className="text-sm font-semibold" style={{ color: "var(--accent-strong)" }}>· {e.company}</span>
                  </div>
                  <div className="mt-1 text-xs font-mono uppercase tracking-widest" style={{ color: "var(--text-secondary)" }}>
                    {e.location}
                  </div>
                  <p className="mt-4 text-sm md:text-base leading-relaxed" style={{ color: "var(--text-secondary)" }}>
                    {e.summary}
                  </p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
